module.exports = __webpack_public_path__ + "media/images/react/members/share/memberShare-aa4aacd646aba31c8103f6e7b0dfbf55.svg";